import { z } from 'zod';

const CountrySchema = z.object({
    value: z.string(),
    text: z.string(),
});

const CountriesResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(CountrySchema),
});

export { CountriesResponseSchema };
export type CountryType = z.infer<typeof CountrySchema>;
export type CountriesResponse = z.infer<typeof CountriesResponseSchema>;